export type ConditionalWrapperChildren = React.ReactNode;

export const ConditionalWrapper = ({
	condition,
	wrapper,
	children,
}: {
	condition: boolean;
	wrapper: (children: ConditionalWrapperChildren) => ConditionalWrapperChildren;
	children: ConditionalWrapperChildren;
}): React.ReactNode => (condition ? wrapper(children) : children);
